import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-paragraph flex-grow-1 d-flex align-items-center flex-wrap gap-2" }
const _hoisted_2 = { class: "app-check-row-box" }
const _hoisted_3 = {
  key: 0,
  class: "fas fa-check"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppCheckRow',
  props: {
    label: {},
    checked: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {


const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: _normalizeClass(["app-check-row d-flex align-items-center w-100 text-start text-primary", { checked: __props.checked }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('click')))
  }, [
    _createElementVNode("span", _hoisted_1, [
      _createTextVNode(_toDisplayString(__props.label) + " ", 1),
      _renderSlot(_ctx.$slots, "extra")
    ]),
    _createElementVNode("span", _hoisted_2, [
      (__props.checked)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})